import { useState, useRef } from 'react';
import { useNavigate } from 'react-router';
import MaterialTable, { Options } from '@material-table/core';
import { Assessment } from '../models/Assessment'
import { getApiAssessmentList, deleteApiAssessmentAssessmentid } from '../services/assessment';
import { urls, route } from '../route';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import { loadTableData } from './loaders';
import { confirmAndDelete } from '../utils';
export const AssessementList = () => {
    const history = useNavigate();
    const ref = useRef<any>();
    const [pagination,] = useState<Options<Assessment>>({
        actionsColumnIndex: -1,
        selection: true,
        maxColumnSort: 0,
        pageSize: 10,
    });
    return <div>
        <MaterialTable<Assessment>
            title="Assessements"
            options={pagination}
            tableRef={ref}
            columns={[
                { title: "Id", field: "id" },
                { title: "Name", field: "name", width: "20%" },
                { title: "Content", render: (e) => <div dangerouslySetInnerHTML={{ __html: e.content || "" }} />, width: "70%"  },
                {
                    title: 'Tools',
                    render: (e) => (<>
                        <IconButton onClick={() => history(`/app/assessement/edit/${e.id}`)} style={{ float: "right" }}><Icon>edit</Icon></IconButton>
                        <IconButton onClick={confirmAndDelete(e, deleteApiAssessmentAssessmentid, ref)} style={{ float: "right" }}><Icon>delete</Icon></IconButton>
                    </>)
                }
            ]}
            data={loadTableData(getApiAssessmentList)}
            actions={[{
                icon: "delete",
                tooltip: "Delete",
                onClick: async (event, data) => {
                    const confirmation = window.confirm("Are you sure you want to delete the selected items?")

                    if (confirmation && Array.isArray(data)) {
                        for (const i of data) {
                            await deleteApiAssessmentAssessmentid(i.id!);
                        }
                        if (ref.current) {
                            ref.current.onQueryChange();
                        }
                    }
                }
            }, {
                icon: "add",
                tooltip: "Add New",
                isFreeAction: true,
                onClick: () => history(route(urls.assessementAdd)),
            }]}
        />

    </div>
};